import { ChangeEvent, FC, PropsWithChildren, useCallback, useRef } from 'react';

import { Button } from '../button';
import { ButtonComponentProps } from '../button/Button';

export interface FileUploadButtonProps extends ButtonComponentProps {
  onFileSelect: ({ file }: { file: File }) => void;
  accept?: string;
  inputAriaLabel?: string;
}

const FileUploadButton: FC<PropsWithChildren<FileUploadButtonProps>> = ({
  onFileSelect,
  accept,
  inputAriaLabel,
  children,
  ...buttonProps
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];

      if (file) {
        onFileSelect({ file });
      }
      event.target.value = '';
    },
    [onFileSelect],
  );

  return (
    <>
      <Button
        {...buttonProps}
        onClick={(event) => {
          buttonProps.onClick?.(event);
          handleClick();
        }}
      >
        {children}
      </Button>

      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
        aria-label={inputAriaLabel}
        hidden
      />
    </>
  );
};

export default FileUploadButton;
